<template>
  <div class="cmp cmp-dialog-login">
    <!-- 登录 -->
    <el-dialog
      class="dialog-login"
      title="登 录"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="620px"
    >
      <el-form
        v-if="loginType === 'password'"
        :model="Form"
        :rules="rules"
        ref="ruleForm1"
      >
        <el-form-item prop="username">
          <el-input
            prefix-icon="el-icon-mobile-phone"
            v-model.trim="Form.username"
            :maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            v-model.trim="Form.password"
            :maxlength="32"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <div class="row-flex">
          <div class="row-flex-prefix">
            <el-button type="text" @click="verifyCodeClick"
              >验证码登录</el-button
            >
          </div>
          <div class="row-flex-main"></div>
          <div class="row-flex-suffix">
            <el-button type="text" @click="forgetPwdClick">忘记密码</el-button>
          </div>
        </div>
        <div>
          <el-button class="btn-login" type="primary" @click="loginByPassword"
            >立即登录</el-button
          >
        </div>
        <div class="text-center">
          没有账号？<el-button type="text" @click="registClick">注册</el-button>
        </div>
      </el-form>
      <el-form
        v-else-if="loginType === 'verifyCode'"
        :model="Form"
        :rules="rules"
        ref="ruleForm2"
      >
        <el-form-item prop="phone">
          <el-input
            prefix-icon="el-icon-mobile-phone"
            v-model.trim="Form.phone"
            :maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="imgCode">
          <div class="row-flex">
            <div class="row-flex-main">
              <el-input
                class="verify-code-input"
                prefix-icon="el-icon-picture-outline"
                v-model.trim="Form.imgCode"
                :maxlength="10"
                placeholder="请输入图形验证码"
              ></el-input>
            </div>
            <div class="row-flex-suffix">
              <img
                class="verify-code-img"
                @click="getImgVerify"
                :src="`data:image/png;base64,${codeSrc}`"
                title="看不清？换一张"
              />
              <!-- <div
                class="verify-code-img"
                v-html="imgCode"
                @click="getImgVerify"
                title="看不清？换一张"
              ></div> -->
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="smsCode">
          <div class="row-flex">
            <div class="row-flex-main">
              <el-input
                class="sms-code-input"
                prefix-icon="el-icon-message"
                v-model.trim="Form.smsCode"
                :maxlength="10"
                placeholder="请输入短信验证码"
              ></el-input>
            </div>
            <div class="row-flex-suffix">
              <el-button
                class="sms-code-btn"
                type="primary"
                plain
                @click="getSmsStep1"
                :disabled="timeTotal > 0"
                >{{
                  timeTotal > 0 ? timeTotal + '秒后重试' : '获取验证码'
                }}</el-button
              >
            </div>
          </div>
        </el-form-item>
        <div class="row-flex">
          <div class="row-flex-prefix">
            <el-button type="text" @click="loginType = 'password'"
              >密码登录</el-button
            >
          </div>
          <div class="row-flex-main"></div>
          <div class="row-flex-suffix">
            <el-button type="text" @click="forgetPwdClick">忘记密码</el-button>
          </div>
        </div>
        <div>
          <el-button class="btn-login" type="primary" @click="loginByVerifyCode"
            >立即登录</el-button
          >
        </div>
        <div class="text-center">
          没有账号？<el-button type="text" @click="registClick">注册</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { EventBus } from '@/assets/scripts/bus';
import api from '@/api/index.js';
import jstools from 'jstools-common/dist/jstools.web';
const phoneRegExp = /^(1[0-9])\d{9}$/;

export default {
  data() {
    let PhoneRules = function (rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入手机号'));
      } else if (!phoneRegExp.test(value)) {
        return callback(new Error('您的手机号不符合规则，请修改后再试'));
      } else {
        api.checkPhoneRegistState({ phone: value }).then((res) => {
          if (res.businessCode === 'PARAM_VALIDATION_ERROR') {
            return callback(new Error('请输入正确的手机号'));
          } else if (res.businessCode === 'SUCCESS' && !res.data) {
            return callback(new Error('您还未注册，请先注册'));
          } else {
            callback();
          }
        });
      }
    };
    return {
      loginType: 'password',
      dialogVisible: false,
      imgCode: '',
      codeSrc: '',
      codeKey: '',
      timeTotal: 0,
      timer: null,
      Form: {
        username: '',
        password: '',
        phone: '',
        imgCode: '',
        smsCode: '',
      },
      rules: {
        username: [{ required: true, validator: PhoneRules, trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' },
        ],
        phone: [{ required: true, validator: PhoneRules, trigger: 'blur' }],
        imgCode: [
          { required: true, message: '请输入图形验证码', trigger: 'change' },
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      activityActive: 'activityActive',
      loginState(state) {
        if (state.loginState === 0) {
          return true;
        } else {
          return false;
        }
      },
    }),
  },
  mounted() {
    EventBus.$on('loginShow', () => {
      this.show();
    });
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setLoginState']),
    ...mapActions(['islogin']),
    forgetPwdClick() {
      this.close();
      EventBus.$emit('forgetPwdShow');
    },
    registClick() {
      this.close();
      EventBus.$emit('registShow');
    },
    show() {
      if (this.dialogVisible) return;
      this.dialogVisible = true;
      this.resetForm();
    },
    close() {
      this.dialogVisible = false;
      this.resetForm();
    },
    verifyCodeClick() {
      this.loginType = 'verifyCode';
      this.getImgVerify();
    },
    getImgVerify() {
      this.imgCode = '';
      this.codeKey = '';
      this.codeSrc = '';
      return api
        .getVerifyCode({ type: 'image' })
        .then((data) => {
          this.codeKey = data.codeKey || '';
          this.codeSrc = data.codeStream || '';
        })
        .catch(() => {
          this.$message.error('获取图片验证码失败');
        });
      // return api
      //   .getImgVerify({ height: 40 })
      //   .then((data) => {
      //     this.imgCode = data.data;
      //   })
      //   .catch(() => {
      //     this.$message.error('获取图片验证码失败');
      //   });
    },
    testImgVerify: jstools.debounce(function () {
      return api
        .testImgVerify({
          code: this.Form.imgCode.toLowerCase(),
        })
        .then((res) => {
          if (res.data === 1) {
            this.$message.error('您输入的图形验证码错误');
          } else if (res.data === 0) {
            this.getSmsStep2();
          } else {
            this.$message.error('图形验证码输入错误');
          }
        });
    }),
    getSmsStep1() {
      this.$refs.ruleForm2.validateField(['phone', 'imgCode'], (error) => {
        // 校验完成后的回调：error为undefined表示校验成功
        if (!error) {
          console.log(`校验成功`);
          this.getSmsStep2();
        } else {
          console.log(`校验失败：`, error);
        }
      });
    },
    getSmsStep2: jstools.debounce(function () {
      api
        .sendPhoneCode({
          phone: this.Form.phone,
          imageCode: this.Form.imgCode,
          phoneCodeType: 'LOGIN',
          headers: { codeKey: this.codeKey },
        })
        .then((res) => {
          console.log('getSmsStep2:', res);
          this.timeReduce();
        })
        .catch((err) => {
          this.smsErrorHandler(err);
        });
    }),
    smsErrorHandler(error) {
      let message = '';
      if (error.code === 1001) {
        message = '请您输入正确的手机号';
      } else if (error.code === 1002) {
        message = '短信发送失败';
      } else if (error.code === 1003) {
        message = '您还未注册,请先注册';
      } else if (error.code === 1004) {
        message = '短信发送失败';
      } else if (error.code === 1005) {
        message = '短信发送失败';
      } else if (error.code === -3) {
        message = '短信发送失败';
      } else if (error.code === 1006) {
        message = '您已经连续发送3次验证码，请1小时后再试';
      }
      this.$message.error(message || error.msg || error.message);
    },
    loginByPassword() {
      this.$refs.ruleForm1.validate((valid) => {
        if (!valid) return false;
        // api
        //   .loginV2({
        //     loginType: 'password',
        //     account: this.Form.username,
        //     password: this.Form.password,
        //   })
        //   .then((res) => {
        //     console.log('登录成功：', res);
        //     // this.loginResHandler(res);
        //     // this.islogin(() => {this.close()});
        //   })
        //   .catch((err) => {
        //     console.log('登录错误：', err);
        //   });
        api
          .loginV3({
            loginType: 'password',
            account: this.Form.username,
            password: this.Form.password,
            code: '',
          })
          .then((res) => {
            console.log('登录成功：', res);
            this.loginResHandler(res);
            this.close();
          })
          .catch((err) => {
            console.log('登录错误：', err);
            this.$message.error(err.msg || '登录错误');
          });
      });
    },
    loginByVerifyCode() {
      this.$refs.ruleForm2.validate((valid) => {
        if (!valid) return false;
        api
          .loginV3({
            loginType: 'verification_code',
            account: this.Form.phone,
            password: '',
            code: this.Form.smsCode,
          })
          .then((res) => {
            console.log('登录成功：', res);
            this.loginResHandler(res);
            this.close();
          })
          .catch((err) => {
            console.log('登录错误：', err);
            this.$message.error(err.msg || '登录错误');
          });
      });
    },
    // islogin() {
    //   return api
    //     .islogin()
    //     .then((res) => {
    //       console.log('islogin res:', res);
    //       let info = res.info;
    //       this.setUserInfo(info);
    //       if (String(res.data) === '0') {
    //         localStorage.setItem('gatewayApiToken', info.accessToken.token); // 存储个人中心token
    //       } else if (String(res.data) === '-2') {
    //         //
    //       } else {
    //         localStorage.removeItem('gatewayApiToken'); // 没有登录删除 gatewayApiToken
    //         sessionStorage.clear();
    //       }
    //       this.loginErrorHandler(info);
    //     })
    //     .catch((err) => {
    //       console.log('islogin err:', err);
    //     });
    // },
    loginResHandler(res = {}) {
      let _this = this;
      let _data = res.data || {};
      let loginCode = {
        SLH_USER_NOT_EXIST: function (data) {
          console.log('用户名不存在', data);
          this.$message.error('用户名不存在');
          _this.setLoginState(2);
        },
        SUCCESS: function (data) {
          console.log('登陆成功', data);
          _this.setLoginState(0);
        },
        PARAM_VALIDATION_ERROR: function (data) {
          console.log('参数验证失败', data);
          this.$message.error('参数验证失败');
          _this.setLoginState(1);
        },
        SLH_USER_CODE_ERROR: function (data) {
          console.log('验证码不正确', data);
          this.$message.error('验证码不正确');
          _this.setLoginState(3);
        },
        PRODUCT_ACCOUNT_SEARCHER_ERROR: function (data) {
          console.log('平台账户查询失败', data);
          this.$message.error('平台账户查询失败');
          _this.setLoginState(4);
        },
        USER_ALREADY_DISABLED: function (data) {
          console.log('用户已经被禁用', data);
          this.$message.error('用户已经被禁用');
          _this.setLoginState(5);
        },
        SLH_USER_PASSWORD_FORMAT_ERROR: function (data) {
          console.log('用户密码验证失败', data);
          this.$message.error('用户密码验证失败');
          _this.setLoginState(6);
        },
        SLH_USER_PASSWORD_ERROR: function (data) {
          console.log('密码错误', data);
          this.$message.error('密码错误');
          _this.setLoginState(7);
        },
        SLH_USER_PASSWORD_NOT_EXIST: function (data) {
          console.log('密码不存在', data);
          this.$message.error('密码不存在');
          _this.setLoginState(2);
        },
        SLH_USER_ADD_ERROR: function (data) {
          console.log('用户添加失败', data);
          this.$message.error('用户添加失败');
          _this.setLoginState(9);
        },
        SLH_USER_LOGIN_ERROR: function (data) {
          console.log('用户登录失败', data);
          this.$message.error('用户登录失败');
          _this.setLoginState(10);
        },
        '-3': function (data) {
          console.log('用户密码超过90天未修改，请先修改密码', data);
          this.$message.error('用户密码超过90天未修改，请先修改密码');
          _this.setLoginState(11);
        },
      };
      loginCode[_data.businessCode] && loginCode[_data.businessCode](res);
      if (res.code === 0) {
        !_data.accessToken &&
          (_data.accessToken = {
            refreshToken: _data.token,
            token: _data.token,
          });
        this.setUserInfo(_data);
      } else {
        this.$message.error(res.msg || '请求错误');
      }
    },
    loginErrorHandler(error) {
      let message = '';
      if (error.code === 0) {
        console.log('登录成功');
        this.close();
      } else if (error.code === 1) {
        message = '用户名或密码错误';
      } else if (error.code === 2) {
        message = '用户不存在，请先注册';
      } else if (error.code === 3) {
        message = '您输入的验证码错误';
      } else if (error.code === 4) {
        message = '您还未注册，请先注册';
      } else if (error.code === 5) {
        message = '您的账号已被禁用，请联系客服';
      } else if (error.code === 6) {
        message = '用户名或密码错误';
      } else if (error.code === 7) {
        message = '用户名或密码错误';
      } else if (error.code === 8) {
        message = '您尚未设置本网站的密码，请您设置密码';
      } else if (error.code === 9) {
        message = '用户名或密码错误';
      } else if (error.code === 10) {
        message = '登录失败，请您重新登录。';
      } else if (error.code === 11) {
        message = '用户密码超过90天未修改，请先修改密码。';
      } else {
        message = '用户未登录';
      }
      message && this.$message.error(message);
    },
    timeReduce() {
      let _this = this;
      clearInterval(this.timer);
      this.timeTotal = 60;
      this.timer = setInterval(() => {
        _this.timeTotal--;
        if (_this.timeTotal <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    resetForm() {
      this.loginType = 'password';
      this.Form = {
        username: '',
        password: '',
        phone: '',
        imgCode: '',
        smsCode: '',
      };
      this.$refs.ruleForm1 && this.$refs.ruleForm1.resetFields();
      this.$refs.ruleForm2 && this.$refs.ruleForm2.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.cmp-dialog-login {
  .sms-code-input,
  .verify-code-input {
    width: 100%;
  }
  .verify-code-img {
    width: 120px;
    height: 40px;
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    background: #dedede;
    /deep/ svg {
      width: 100%;
      height: 100%;
    }
  }
  .sms-code-btn {
    width: 120px;
  }
  .btn-login {
    width: 100%;
  }
  /deep/ .el-dialog__body {
    padding: 15px 30px;
  }
}
</style>
